/* Copia link per i bottoni senza share-URL (Instagram, TikTok) */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.social-sharing__btn[data-share-copy]');
    if (!btn) return;
    e.preventDefault();

    var url = btn.getAttribute('data-share-copy');
    var msg = btn.getAttribute('data-copied-text') || 'Link copiato';
    var tip = btn.querySelector('.social-sharing__tip');

    function done() {
      if (tip) tip.textContent = msg;
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.classList.remove('is-copied');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(fallback);
    } else {
      fallback();
    }

    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch (err) {}
      document.body.removeChild(ta);
      done();
    }
  });
})();
